// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1ab9832c","703":"f2c60403"}[chunkId] + ".chunk.js";
};